import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { USER } from 'src/app/core/user.service';
import {
  justificationRequiredForRestTimesLessThan10Hours,
  restTimeLessThan10Hours,
  startTimeMustBeGreaterThanPreviousEndTime,
  startTimeMustNotExeed30MinutesFromNow,
} from 'src/app/duty-logs/duty-log-form-validators';
import { BaseEntity } from 'src/store/base/base.model';
import { getValueChanges } from 'src/util/angular/ng-forms-helpers';
import { field, getValidationErrorsChangesDeep } from 'src/util/angular/ng-forms-validation';
import { kendoDateTime24HourFormat, toDate } from 'src/util/dateLib';
import { UserViewModel } from 'src/view-models/user-view-model';

export interface DutyOnFormParams {
  baseId?: string;
  aircraftId?: string;
  employeeId: string;
  prevEntryEndTime?: Date;
}
@Component({
  selector: 'fl-duty-on-form',
  templateUrl: './duty-on-form.component.html',
  styleUrls: ['./duty-on-form.component.scss'],
})
export class DutyOnFormComponent implements OnInit {
  @Input()
  public params: DutyOnFormParams;
  @Output()
  public baseSelected = new EventEmitter<BaseEntity>();

  public dateTimeFormat = kendoDateTime24HourFormat;
  public form: FormGroup;
  public errors$: Observable<string[]>;
  public restTimeLessThan10Hours$: Observable<boolean>;
  public refresh$ = new BehaviorSubject<{}>({});

  constructor(@Inject(USER) public user: UserViewModel, private _fb: FormBuilder) {}

  public async ngOnInit() {
    const prevEndTime =
      this.params.prevEntryEndTime != null ? toDate(this.params.prevEntryEndTime) : null;

    this.form = this._fb.group(
      {
        employeeId: this.params.employeeId,
        baseId: [this.params.baseId, field('Base', { required: true })],
        aircraftId: [this.params.aircraftId, field('Aircraft', { required: true })],
        dutyPeriodStartTime: [
          new Date(),
          field('Duty on time', {
            required: true,
            validators: [
              startTimeMustBeGreaterThanPreviousEndTime(prevEndTime),
              startTimeMustNotExeed30MinutesFromNow,
            ],
          }),
        ],
        comments: null,
        restJustification: null,
      },
      {
        validators: [justificationRequiredForRestTimesLessThan10Hours(prevEndTime)],
      },
    );

    this.restTimeLessThan10Hours$ = getValueChanges(this.form).pipe(
      map((form) => restTimeLessThan10Hours(form, prevEndTime)),
    );
    this.errors$ = getValidationErrorsChangesDeep(this.form);
  }

  public onBaseSelected(base: BaseEntity) {
    this.baseSelected.emit(base);
  }
}
